"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-lines-per-function */
const summithill_models_1 = require("@clearsummit/summithill-models");
const humps_1 = require("humps");
const ApiService_1 = __importDefault(require("../ApiService"));
// import Mixpanel from './mixpanel'
const LOGIN_USER_URL = '/accounts/login/';
const SIGNUP_URL = '/accounts/signup/';
const ME_URL = '/accounts/me/';
const RESET_PASSWORD = '/accounts/reset-password/';
const CHANGE_PASSWORD = '/accounts/change-password/';
const LOGOUT_USER_URL = 'accounts/logout/';
const PROGRAM_URL = `/programs/{id}/`;
const LIST_PROGRAMS_URL = `/programs/`;
const LIST_SECTIONS_SIMPLE_URL = `/sections-simple/`;
const SECTIONS_URL = `/sections/`;
const VERIFY_EMAIL_URL = '/accounts/verify-email';
const VIDEO_STATE_URL = '/videos/{id}/state/';
const ANSWER_PROCESS_QUESTIONS_URL = '/process-question/{id}/answer/';
const SUPPORT_URL = '/support/';
const CREATE_PAYMENT_URL = '/payments/create-payment/';
const LIST_USERS_URL = '/accounts/';
const BULK_USERS_URL = '/accounts/bulk/';
const LIST_CAREGIVERS_URL = `/caregivers/`;
const CREATE_USER_URL = `/accounts/`;
const GET_USER_URL = `/accounts/{id}/`;
const UPDATE_USER_URL = `/accounts/{id}/`;
const DELETE_USER_URL = `/accounts/{id}/`;
const LIST_PATIENT_PROGRESS_URL = `/patient-progress/`;
const GET_PATIENT_PROCESS_QUESTION_URL = (patientId, contentId) => `/patient-progress/${patientId}/process-questions/${contentId}/`;
const GET_PATIENT_PROGRESS_URL = `/patient-progress/{id}/`;
const UPDATE_PATIENT_PROGRESS_SECTION_URL = `/patient-progress/{id}/section/`;
const UPDATE_PATIENT_PROGRESS_CONTENT_URL = `/patient-progress/{id}/content/`;
const GET_THERAPY_NOTE_URL = `/therapy-note/{id}/`;
const CREATE_THERAPY_NOTE_URL = `/therapy-note/`;
const UPDATE_THERAPY_NOTE_URL = `/therapy-note/{id}/`;
const DELETE_THERAPY_NOTE_URL = `/therapy-note/{id}/`;
const GET_USER_SESSION_URL = `/user-sessions/{id}/`;
const LIST_PROGRAMS_ADMIN_URL = `/programs-admin/`;
const DETAIL_PROGRAMS_ADMIN_URL = (id) => `/programs-admin/${id}/`;
const DELETE_PROGRAM_ADMIN_URL = `/programs-admin/{id}/`;
const LIST_SECTIONS_ADMIN_URL = `/sections-admin/`;
const DETAIL_SECTIONS_ADMIN_URL = (id) => `/sections-admin/${id}/`;
const DELETE_SECTION_ADMIN_URL = `/sections-admin/{id}/`;
const axiosAdaptor = (fn, args) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    let resp;
    let err;
    try {
        const response = yield fn(args);
        resp = { statusCode: response.status, data: response.data };
    }
    catch (e) {
        err = { statusCode: e.response.status, details: e.response.data.detail, error: (_a = e.response.data) === null || _a === void 0 ? void 0 : _a.error };
    }
    return [resp, err];
});
const Api = {
    get: (arg) => axiosAdaptor(ApiService_1.default.get, arg),
    post: (arg) => axiosAdaptor(ApiService_1.default.post, arg),
    put: (arg) => axiosAdaptor(ApiService_1.default.put, arg),
    patch: (arg) => axiosAdaptor(ApiService_1.default.patch, arg),
    delete: (arg) => axiosAdaptor(ApiService_1.default.delete, arg),
};
/**
  * @param {api} ApiService
  * @return Object passed to the api saga, each value must be an asyn function that returns Array<ResponeType, ErrorType>
  * supported by the radio-disptach api-saga
 */
const ApiServices = () => {
    // General pagination endpoint
    const getNextPage = (url, responseType) => Api.get({ url, responseType });
    // @ts-ignore
    const login = (data) => Api.post({ url: LOGIN_USER_URL, payload: data, responseType: summithill_models_1.ModelTypes.User });
    const signup = (data) => Api.post({ url: SIGNUP_URL, payload: data, responseType: summithill_models_1.ModelTypes.User });
    // @ts-ignore
    const me = () => Api.get({ url: ME_URL, responseType: summithill_models_1.ModelTypes.User });
    // @ts-ignore
    const updateMe = (data) => Api.post({ url: ME_URL, payload: data, responseType: summithill_models_1.ModelTypes.User });
    const getResetPassword = (data) => Api.get({
        url: RESET_PASSWORD,
        payload: {
            username: encodeURI(data.username),
        },
    });
    const postResetPassword = (data) => Api.post({ url: RESET_PASSWORD, payload: data });
    const createPassword = (data) => postResetPassword(data);
    const changePassword = (data) => Api.post({ url: CHANGE_PASSWORD, payload: data });
    const logoutUser = () => { var _a; return Api.post({ url: LOGOUT_USER_URL, payload: { refresh: (_a = ApiService_1.default === null || ApiService_1.default === void 0 ? void 0 : ApiService_1.default.authToken) === null || _a === void 0 ? void 0 : _a.refresh } }); };
    const verifyEmailGet = (data) => Api.get({ url: VERIFY_EMAIL_URL, params: { username: data.username } });
    const verifyEmailPost = (data) => Api.post({ url: VERIFY_EMAIL_URL, payload: { token: data.token } });
    // PROGRAMS
    const getProgram = (id) => Api.get({ url: PROGRAM_URL.replace('{id}', `${id}`), responseType: summithill_models_1.ModelTypes.Program });
    const getSections = (data) => Api.get({
        url: SECTIONS_URL,
        payload: {
            program: data.id,
            page: data.page || 1,
        },
        responseType: summithill_models_1.ModelTypes.SectionsResponse,
    });
    const sendSupportMessage = (data) => Api.post({
        url: SUPPORT_URL,
        payload: Object.assign(Object.assign({}, data), { support_type: data.type }),
    });
    const setVideoState = (data) => Api.post({
        url: VIDEO_STATE_URL.replace('{id}', data.videoId),
        payload: {
            state: data.state,
        },
        responseType: summithill_models_1.ModelTypes.Video,
    });
    const answerProcessQuestions = (data) => Api.post({
        url: ANSWER_PROCESS_QUESTIONS_URL.replace('{id}', data.pk),
        payload: data.data,
        responseType: summithill_models_1.ModelTypes.ProcessQuestion,
    });
    // PAYWALL
    const createPayment = (data) => Api.post({
        url: CREATE_PAYMENT_URL,
        payload: Object.assign({}, data)
    });
    // MANAGE ACCOUNTS
    const listUsers = (data) => Api.get({ url: LIST_USERS_URL, payload: data });
    const listPrograms = (data) => Api.get({ url: LIST_PROGRAMS_URL, payload: data });
    const listCaregivers = () => Api.get({ url: LIST_CAREGIVERS_URL });
    const bulkUsers = (data) => Api.post({
        url: BULK_USERS_URL,
        payload: Object.assign({}, humps_1.decamelizeKeys(data))
    });
    const createUser = (data) => Api.post({
        url: CREATE_USER_URL,
        payload: Object.assign({}, humps_1.decamelizeKeys(data))
    });
    const getUser = (id) => Api.get({ url: GET_USER_URL.replace('{id}', `${id}`), responseType: summithill_models_1.ModelTypes.User });
    const updateUser = (data) => Api.patch({
        url: UPDATE_USER_URL.replace('{id}', `${data.id}`),
        payload: Object.assign({}, humps_1.decamelizeKeys(data))
    });
    const deleteUser = (data) => Api.delete({ url: DELETE_USER_URL.replace('{id}', `${data.id}`) });
    // PATIENT PROGRESS
    const listSectionsSimple = (data) => Api.get({ url: LIST_SECTIONS_SIMPLE_URL, payload: data });
    const listPatientProgress = (data) => Api.get({ url: LIST_PATIENT_PROGRESS_URL, payload: Object.assign({}, humps_1.decamelizeKeys(data)) });
    const getPatientProcessQuestion = (data) => Api.get({
        url: GET_PATIENT_PROCESS_QUESTION_URL(data.patientId, data.contentId)
    });
    const getPatientProgress = (data) => Api.get({ url: GET_PATIENT_PROGRESS_URL.replace('{id}', `${data === null || data === void 0 ? void 0 : data.id}`) });
    const updatePatientProgressSection = (data) => Api.patch({
        url: UPDATE_PATIENT_PROGRESS_SECTION_URL.replace('{id}', `${data === null || data === void 0 ? void 0 : data.id}`),
        payload: Object.assign({}, humps_1.decamelizeKeys(data))
    });
    const updatePatientProgressContent = (data) => Api.patch({
        url: UPDATE_PATIENT_PROGRESS_CONTENT_URL.replace('{id}', `${data === null || data === void 0 ? void 0 : data.id}`),
        payload: Object.assign({}, humps_1.decamelizeKeys(data))
    });
    const getTherapyNote = (data) => Api.get({ url: GET_THERAPY_NOTE_URL.replace('{id}', `${data === null || data === void 0 ? void 0 : data.id}`), responseType: summithill_models_1.ModelTypes.TherapyNote });
    const createTherapyNote = (data) => Api.post({
        url: CREATE_THERAPY_NOTE_URL,
        payload: Object.assign({}, humps_1.decamelizeKeys(data))
    });
    const updateTherapyNote = (data) => Api.patch({
        url: UPDATE_THERAPY_NOTE_URL.replace('{id}', `${data === null || data === void 0 ? void 0 : data.id}`),
        payload: Object.assign({}, humps_1.decamelizeKeys(data)),
        responseType: summithill_models_1.ModelTypes.TherapyNote
    });
    const getUserSession = (data) => Api.get({ url: GET_USER_SESSION_URL.replace('{id}', `${data === null || data === void 0 ? void 0 : data.id}`) });
    const deleteTherapyNote = (data) => Api.delete({ url: DELETE_THERAPY_NOTE_URL.replace('{id}', `${data === null || data === void 0 ? void 0 : data.id}`) });
    // MANAGE PROGRAMS
    const createProgram = (data) => Api.post({
        url: LIST_PROGRAMS_ADMIN_URL,
        payload: data
    });
    const getProgramDetail = (data) => Api.get({
        url: DETAIL_PROGRAMS_ADMIN_URL(data.id)
    });
    const editProgram = (data) => Api.patch({
        url: DETAIL_PROGRAMS_ADMIN_URL(data.id),
        payload: {
            name: data.name
        }
    });
    const deleteProgramAdmin = (data) => Api.delete({ url: DELETE_PROGRAM_ADMIN_URL.replace('{id}', `${data === null || data === void 0 ? void 0 : data.id}`) });
    const createSection = (data) => Api.post({
        url: LIST_SECTIONS_ADMIN_URL,
        payload: data
    });
    const editSection = (data) => Api.patch({
        url: DETAIL_SECTIONS_ADMIN_URL(data.id),
        payload: data
    });
    const deleteSection = (data) => Api.delete({ url: DELETE_SECTION_ADMIN_URL.replace('{id}', `${data === null || data === void 0 ? void 0 : data.id}`) });
    return {
        getNextPage,
        login,
        signup,
        me,
        updateMe,
        getResetPassword,
        postResetPassword,
        createPassword,
        changePassword,
        logoutUser,
        verifyEmailGet,
        verifyEmailPost,
        getProgram,
        listPrograms,
        listCaregivers,
        getSections,
        setVideoState,
        answerProcessQuestions,
        sendSupportMessage,
        createPayment,
        listUsers,
        bulkUsers,
        createUser,
        getUser,
        updateUser,
        deleteUser,
        listSectionsSimple,
        listPatientProgress,
        getPatientProcessQuestion,
        getPatientProgress,
        updatePatientProgressSection,
        updatePatientProgressContent,
        getTherapyNote,
        createTherapyNote,
        updateTherapyNote,
        deleteTherapyNote,
        getUserSession,
        createProgram,
        getProgramDetail,
        editProgram,
        createSection,
        editSection,
        deleteProgramAdmin,
        deleteSection
    };
};
const services = ApiServices();
exports.default = services;
